import React, { useRef } from 'react';
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { FaEdit } from 'react-icons/fa';
import { FiTarget } from 'react-icons/fi';
import { MdAdd, MdDelete } from 'react-icons/md';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { allBranchDetail, allDoctorDetail, allDoctorSearchDetail, appointementGetById } from '../../../redux/actions/Files.action';
import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { addConsultant, billHistory, deleteConsultant, downloadBill, finalBill, finalBillByType, finalBillData, finalBillDelete, finalBillOtp, getAllServices, getConsultant, getFileCharge, searchAllServices, updateConsultant } from '../../../redux/actions/Account.action';
import ReactPaginate from 'react-paginate';
import { PiWarningCircleBold } from 'react-icons/pi';
import { toast } from 'react-toastify';
import Index from 'views/billing/Index';
import logo from "assets/img/Sculpt-logo.png";
import moment from 'moment-timezone';
import { ErrorMessage, Formik, Form as FormikForm } from 'formik'; // also import FormikForm properly
import * as Yup from 'yup';


export default function GenerateBill() {

    const { id } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const branchData = useSelector((state) => state.files)
    const billData = useSelector((state) => state.account)
    const billRef = useRef();
    const fileCharges = billData?.getFileCharge?.data?.fileCharges

    const [show, setShow] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [serviceModal, setServiceModal] = useState(false);
    const [billModal, setBillModal] = useState(false);
    const [deleteFinal, setDeleteFinal] = useState(false);
    const [finalBillId, seFinalBillId] = useState()
    const [reportModal, setReportModal] = useState(false);
    const [formData, setFormData] = useState({
        doctorName: '',
        billDate: new Date().toISOString().split("T")[0],
        totalAmount: '',
        originalAmount: 0,
        filechargeDiscount: '',
        filechargeDiscountRs: '',
        consultationDiscount: '',
        consultationDiscountRs: '',
        serviceName: '',
        serviceRate: '',
        serviceQty: '',
        serviceDiscount: '0',
        serviceDiscountRs: '0',
        serviceTotal: '',
        serviceGst: '',
        serviceDiscountAmount: '',
        serviceRemark: '',
        packageName: '',
        packageServices: [],
        packageRate: '',
        packageQty: '',
        packageDiscount: '',
        packageDiscountRs: '',
        totalSeating: '',
        amount: '',
        serviceId: ''
    })
    console.log('formData', formData);

    const [allData, setAllData] = useState()
    const [readyToPrint, setReadyToPrint] = useState(false);
    const newWindowRef = useRef(null);

    const toggle = () => { setShow(!show) }
    const deleteToggle = () => { setDeleteModal(!deleteModal); };
    const updateToggle = () => { setUpdateModal(!updateModal); };
    const serviceToggle = () => { setServiceModal(!serviceModal); };
    const billToggle = () => { setBillModal(!billModal); };
    const reportToggle = () => { setReportModal(!reportModal); };
    const deleteFinalToggle = () => { setDeleteFinal(!deleteFinal) }

    const [otpModal, setOtpModal] = useState(false);
    const [otpData, setOtpData] = useState({ enteredOtp: '' })
    const [loader, setLoader] = useState(false);
    const otpToggle = () => {
        setLoader(true);
        deleteFinalToggle();
        setOtpModal(!otpModal)
        const payload = {
            billId: finalBillId
        }
        dispatch(finalBillOtp(payload)).then(() => {
            deleteFinalToggle();
            setLoader(false);
        })
    };
    const initialValues = {
        billDate: formData.billDate || '',
    };
    const validationSchema = Yup.object().shape({
        billDate: Yup.string().required('Bill Date is required'),
    });

    const [billId, setBillId] = useState()
    const [billDate, setBillDate] = useState()
    const [historyId, setHistoryId] = useState()
    const [selectedOption, setSelectedOption] = useState("");
    const [reportData, setReportData] = useState("")
    const [doctorData1, setDoctorData1] = useState(false);
    const [selectedDoctor, setSelectedDoctor] = useState('');
    const [serviceData1, setServiceData1] = useState(false);
    const [selectedService, setSelectedService] = useState('');
    const [serviceData2, setServiceData2] = useState(false);
    const [selectedService2, setSelectedService2] = useState('');
    const [isMultiplyChecked, setIsMultiplyChecked] = useState(false);

    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        search: '',
    });

    const [serviceSeating, setServiceSeating] = useState('');
    const [packageServices, setPackageServices] = useState([]);
    const [totalSeating, setTotalSeating] = useState(0);

    const [searchType, setSearchType] = useState('Doctor');
    const [totalAmountInput, setTotalAmountInput] = useState('');
    const [allService, setAllService] = useState()
    const [selectedOption1, setSelectedOption1] = useState('ALL');
    const [selectedDate, setSelectedDate] = useState('');

    const userId = branchData?.getAppointmentById?.data?.appointmentData?.patientId
    console.log("packageServices", packageServices);
    useEffect(() => {
        console.log("selectedService2", selectedService2);
        if (selectedService2) {
            selectService1({
                serviceName: selectedService2,
                serviceRate: formData.packageRate,
                seating: serviceSeating,
                serviceGst: formData.serviceGst,
            });
        }
        if (packageServices.length > 0) {
            // const {
            //     newTotalRate,
            //     newTotalSeating,
            //     discountAmount,
            //     newTotalAmount,
            // } = calculateTotals(packageServices, isMultiplyChecked);
            // if (!isMultiplyChecked) {
            //     setFormData((prev) => ({
            //         ...prev,
            //         totalAmount: parseInt(formData.totalAmount) / 2,
            //     }));
            // } else {
            //     setFormData((prev) => ({
            //         ...prev,
            //         totalAmount: parseInt(formData.totalAmount) * 2,
            //     }));
            // }

            // setTotalSeating(newTotalSeating);
        }
    }, [isMultiplyChecked, packageServices]);

    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        billData?.finalBillData?.data?.totalCount / postPerPage,
    );

    const [billDatas, setBillDatas] = useState({
        billRemark: '',
        paidAmount: ''
    })

    const handleBill = (e) => {
        const { name, value } = e.target;
        if (name === 'paidAmount' && !/^\d*$/.test(value)) {
            return; // Ignore non-digit input
        }
        setBillDatas((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const selectDoctor = (doctorName) => {
        setSelectedDoctor(doctorName);
        setDoctorData1(false)
        setSearchQuery('');
        setSearchDefault({ page: '', search: '' });
    };

    const searchData = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        const newSearchParams = {
            ...searchDefault,
            search: newSearchQuery || ''
        };
        setSearchDefault(newSearchParams);
        if (searchType === 'Doctor') {
            dispatch(allDoctorSearchDetail(newSearchQuery))
        }
        else {
            dispatch(searchAllServices(newSearchQuery))
        }
    };

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
        setBillDatas({
            billRemark: '',
            paidAmount: ''
        })
    }

    const handleChange1 = (event) => {
        setSelectedOption1(event.target.value);
    }

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };

    useEffect(() => {
        dispatch(allBranchDetail())
        dispatch(allDoctorDetail())
        dispatch(getAllServices())
        dispatch(getFileCharge())
        if (id) {
            dispatch(appointementGetById(id))
        }
    }, [id])

    useEffect(() => {
        if (userId) {
            dispatch(getConsultant(userId))
            dispatch(finalBillData(limits, userId, selectedDate))
        }
    }, [userId, rowsPerPage, mainPage, selectedDate])

    const formatDateTime = (isoDate) => {
        const date = new Date(isoDate);
        const formattedDate = date.toLocaleDateString('en-GB');
        const formattedTime = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });

        return `${formattedDate} | ${formattedTime}`;
    };

    const calculateTotal = (rate, seating, discount) => {
        if (selectedOption === 'SERVICE') {
            const subtotal = rate * seating;
            const discountAmount = (subtotal * discount) / 100;
            const totalAmount = subtotal - discountAmount;
            return {
                serviceTotal: totalAmount.toFixed(0),
                serviceDiscountAmount: discountAmount.toFixed(2)
            };
        }

        if (selectedOption === 'PACKAGE') {
            const subtotal = rate * seating;
            const discountAmount = (subtotal * discount) / 100;
            const totalAmount = subtotal - discountAmount;

            return {
                totalAmount: totalAmount.toFixed(0),
                serviceDiscountAmount: discountAmount.toFixed(2)
            };
        }
    };

    const selectService = (service) => {
        const rate = parseInt(service.serviceRate) || 0;
        const seating = service.seating || 1;
        const calculated = calculateTotal(rate, seating, 0);

        const totalAmount =
            selectedOption === 'SERVICE'
                ? calculated.serviceTotal
                : calculated.totalAmount;

        setSelectedService(service.serviceName);
        setServiceSeating(seating);

        if (selectedOption === 'SERVICE') {
            setFormData((prev) => ({
                ...prev,
                serviceRate: rate.toFixed(0),
                serviceQty: seating,
                serviceGst: service.serviceGst,
                serviceTotal: totalAmount,
                serviceDiscount: '',
                serviceDiscountRs: '',
                serviceDiscountAmount: '0'
            }));
        }
        setServiceData1(false);
    };

    const calculateTotalForMultiply = (rate, seating, discount, Multiply) => {
        if (Multiply) {
            const subtotal = rate * seating;
            const discountAmount = (subtotal * discount) / 100;
            const totalAmount = subtotal - discountAmount;
            return {
                totalAmount: totalAmount.toFixed(0),
                serviceDiscountAmount: discountAmount.toFixed(2)
            };
        } else {
            const subtotal = rate;
            const discountAmount = (subtotal * discount) / 100;
            const totalAmount = subtotal - discountAmount;

            return {
                totalAmount: totalAmount.toFixed(0),
                serviceDiscountAmount: discountAmount.toFixed(2)
            };
        }
    };

    const selectService1 = (service) => {

        const rate1 = parseInt(service.serviceRate) || 0;
        const seating1 = service.seating || 1;
        const totalAmount1 = calculateTotalForMultiply(rate1, seating1, 0, isMultiplyChecked).totalAmount;
        console.log("totalAmount1", totalAmount1);

        setSelectedService2(service.serviceName);
        setServiceSeating(seating1);

        if (selectedOption === 'PACKAGE') {
            setFormData((prev) => ({
                ...prev,
                packageRate: rate1.toFixed(0),
                packageQty: seating1,
                serviceGst: service.serviceGst,
                totalAmount: totalAmount1,
                serviceId: service._id
            }));
        }
        setServiceData2(false);
    };

    const handleData = (e) => {
        const { name, value } = e.target;

        if (name === "amount" && !/^\d*$/.test(value)) {
            return; // Ignore non-digit input
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

        let updatedData = { ...formData, [name]: value };

        if (name === "filechargeDiscount") {
            // Discount in percentage
            const discountPercent = parseFloat(value) || 0;
            if (discountPercent > 0) {
                updatedData.totalAmount = (formData.originalAmount - (formData.originalAmount * discountPercent) / 100).toFixed(0);
            } else {
                updatedData.totalAmount = formData.originalAmount;
            }
            updatedData.filechargeDiscountRs = "";
        } else if (name === "filechargeDiscountRs") {
            // Discount in Rs
            const discountRs = parseInt(value) || 0;
            if (discountRs > 0) {
                updatedData.totalAmount = (formData.originalAmount - discountRs).toFixed(0);
            } else {
                updatedData.totalAmount = formData.originalAmount;
            }
            updatedData.filechargeDiscount = "";
        }

        if (name === "consultationDiscount") {
            const discountPercent = parseFloat(value) || 0;
            if (discountPercent > 0) {
                updatedData.totalAmount = (
                    formData.originalAmount -
                    (formData.originalAmount * discountPercent) / 100
                ).toFixed(0);
            } else {
                updatedData.totalAmount = formData.originalAmount;
            }
            updatedData.consultationDiscountRs = "";
        } else if (name === "consultationDiscountRs") {
            const discountRs = parseInt(value) || 0;
            if (discountRs > 0) {
                updatedData.totalAmount = (
                    formData.originalAmount - discountRs
                ).toFixed(0);
            } else {
                updatedData.totalAmount = formData.originalAmount;
            }
            updatedData.consultationDiscount = "";
        }

        setFormData(updatedData);

        if (selectedOption === 'SERVICE') {
            const rate = parseInt(formData.serviceRate) || 0;
            const seating = name === 'serviceQty' ? parseInt(value, 10) : parseInt(formData.serviceQty, 10) || 1;
            let discountAmount = 0;
            let totalAmount = rate * seating;


            if (name === 'serviceDiscount' || formData.serviceDiscount) {
                const discount = name === 'serviceDiscount' ? parseFloat(value) : parseFloat(formData.serviceDiscount) || 0;
                if (discount >= 0 && discount <= 100) {
                    discountAmount = (rate * seating * discount) / 100;
                    totalAmount = rate * seating - discountAmount;
                }
            }

            // Calculate total based on fixed discount (₹)
            if (name === 'serviceDiscountRs' || formData.serviceDiscountRs) {
                const discountRs = name === 'serviceDiscountRs' ? parseInt(value, 10) || 0 : parseInt(formData.serviceDiscountRs, 10) || 0;
                discountAmount = Math.min(discountRs, rate * seating);
                totalAmount = rate * seating - discountAmount;
            }

            totalAmount = Math.max(totalAmount, 0);

            setFormData((prev) => ({
                ...prev,
                serviceTotal: totalAmount,
                serviceDiscountAmount: discountAmount
            }));
        }

        if (selectedOption === 'PACKAGE') {
            let rate1 = 0
            if (show) {
                rate1 = parseInt(formData.packageRate) || 0;
            } else {
                rate1 = parseInt(formData.serviceRate) || 0;
            }
            const seating1 = parseInt(formData.serviceQty) || 1;
            let discountAmount = 0;
            let totalAmount = rate1 * seating1;

            if (name === 'packageDiscount' || formData.packageDiscount) {
                const discount = name === 'packageDiscount' ? parseFloat(value) || 0 : parseFloat(formData.packageDiscount) || 0;
                if (discount >= 0 && discount <= 100) {
                    discountAmount = (rate1 * seating1 * discount) / 100;
                    // totalAmount = rate1 * seating1 - discountAmount;
                }
            }

            if (name === 'packageDiscountRs' || formData.packageDiscountRs) {
                const discountRs = name === 'packageDiscountRs' ? parseFloat(value) || 0 : parseFloat(formData.packageDiscountRs) || 0;
                discountAmount = Math.min(discountRs, rate1 * seating1);
                // totalAmount = rate1 * seating1 - discountAmount;
            }

            discountAmount = Math.min(discountAmount, rate1 * seating1);

            totalAmount = rate1 * seating1 - discountAmount;


            // Prevent negative total amount
            totalAmount = Math.max(totalAmount, 0);


            setFormData((prev) => ({
                ...prev,
                serviceDiscountAmount: discountAmount,
                totalAmount: totalAmount,
                [name]: value || "",
            }));
        }
    };

    const handleAddConslutant = (e) => {
        // e.preventDefault();

        const now = new Date();
        // const currentDate = now.toISOString().split('T')[0];
        let hours = now.getHours();
        const minutes = now.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12;
        hours = hours ? hours : 12;
        const formattedTime = `${hours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;

        let payload = {
            patientId: userId,
            type: selectedOption,
        };

        if (selectedOption === 'FILECHARGE') {
            payload = {
                ...payload,
                date: formData.billDate,
                time: formattedTime,
                doctorName: selectedDoctor,
                filechargeDiscount: formData.filechargeDiscount,
                filechargeDiscountRs: formData.filechargeDiscountRs,
                totalAmount: formData.totalAmount,
            };
        } else if (selectedOption === 'CONSULTANT') {
            payload = {
                ...payload,
                date: formData.billDate,
                time: formattedTime,
                doctorName: selectedDoctor,
                consultationDiscount: formData.consultationDiscount,
                consultationDiscountRs: formData.consultationDiscountRs,
                totalAmount: formData.totalAmount,
            };
        } else if (selectedOption === 'SERVICE') {
            payload = {
                ...payload,
                date: formData.billDate,
                serviceData: {
                    serviceName: selectedService,
                    serviceRate: formData.serviceRate,
                    serviceQty: formData.serviceQty,
                    serviceDiscount: formData.serviceDiscount,
                    serviceGst: formData.serviceGst,
                    serviceTotal: formData.serviceTotal,
                    serviceRemark: formData.serviceRemark,
                    serviceDiscountAmount: formData.serviceDiscountAmount,
                    serviceDiscountRs: formData.serviceDiscountRs
                }
            };
        }
        else if (selectedOption === 'PACKAGE') {
            payload = {
                ...payload,
                date: formData.billDate,
                packageName: formData.packageName,
                packageServices: packageServices,
                totalSeating: totalSeating,
                packageDiscount: formData.packageDiscount,
                packageDiscountRs: formData.packageDiscountRs,
                serviceDiscountAmount: formData.serviceDiscountAmount,
                totalAmount: formData.totalAmount || 0,
                serviceRate: formData.packageRate
            }
        }

        dispatch(addConsultant(payload, userId)).then(() => {
            toggle();
            setFormData({
                doctorName: '',
                totalAmount: '',
                serviceName: '',
                serviceRate: '',
                serviceQty: '',
                serviceTotal: '',
                serviceGst: '',
                serviceRemark: '',
                packageName: '',
                packageRate: '',
                packageQty: '',
                serviceDiscountRs: '',
                packageDiscountRs: '',
                filechargeDiscount: '',
                filechargeDiscountRs: '',
                consultationDiscount: '',
                consultationDiscountRs: ''
            });
            setSelectedDoctor('');
            setSelectedService('');
            setPackageServices([]);
        });
    }

    const handleUpdateConslutant = (e) => {
        e.preventDefault();

        const now = new Date();
        const currentDate = now.toISOString().split('T')[0];
        let hours = now.getHours();
        const minutes = now.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12;
        hours = hours ? hours : 12;

        const formattedTime = `${hours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
        let payload = {
            billingId: billId,
            type: selectedOption,
        };

        if (selectedOption === 'FILECHARGE' || selectedOption === 'CONSULTANT') {
            payload = {
                ...payload,
                date: formData.billDate,
                time: formattedTime,
                doctorName: selectedDoctor,
                totalAmount: formData.totalAmount,
            };
        } else if (selectedOption === 'SERVICE') {
            payload = {
                ...payload,
                date: formData.billDate,
                serviceData: {
                    serviceName: selectedService,
                    serviceRate: formData.serviceRate,
                    serviceQty: formData.serviceQty,
                    serviceDiscount: formData.serviceDiscount,
                    serviceGst: formData.serviceGst,
                    serviceTotal: formData.serviceTotal,
                    serviceRemark: formData.serviceRemark,
                    serviceDiscountAmount: formData.serviceDiscountAmount,
                    serviceDiscountRs: formData.serviceDiscountRs
                }
            };
        }
        else if (selectedOption === 'PACKAGE') {
            payload = {
                ...payload,
                date: formData.billDate,
                packageName: formData.packageName,
                packageServices: packageServices,
                totalSeating: totalSeating,
                packageDiscount: formData.packageDiscount,
                packageDiscountRs: formData.packageDiscountRs,
                serviceDiscountAmount: formData.serviceDiscountAmount,
                totalAmount: formData.totalAmount || 0,
                serviceRate: formData.packageRate
            }
        }

        dispatch(updateConsultant(payload, userId)).then(() => {
            updateToggle()
            setFormData({
                doctorName: '',
                totalAmount: '',
                serviceName: '',
                serviceRate: '',
                serviceQty: '',
                serviceTotal: '',
                serviceGst: '',
                serviceRemark: '',
                packageRate: '',
                packageQty: '',
                packageName: '',
                packageDiscountRs: '',
                serviceDiscountRs: ''
            });
            setSelectedService('');
            setPackageServices([])
        })
    }

    const handleDeleteConsultat = () => {
        dispatch(deleteConsultant(billId, userId)).then(() => {
            deleteToggle()
            setBillDatas({
                billRemark: '',
                paidAmount: ''
            })
            setBillDiscount('')
            setBillDiscountPercentage('')
            setTotal('')
            setTotalGST('')
            setTotalAmount('')
        })
    }

    useEffect(() => {
        const billings = billData?.getConsultant?.data?.Billings;
        if (billings?.length > 0) {
            const lastBilling = billings[billings.length - 1];
            setTotalAmountInput(lastBilling.totalAmount || 0);
        }
    }, [billData]);

    const handleMultiplyChange = (e) => {
        setIsMultiplyChecked(e.target.checked);
    };

    const calculateTotals = (services, MultiplyChecked) => {
        const newTotalRate = services.reduce((total, service) => {
            const rate = parseFloat(service.serviceRate) || 0;
            const seating = parseInt(service.seating, 10) || 0;
            return total + (isMultiplyChecked ? rate * seating : rate);
        }, 0);

        const newTotalSeating = services.reduce((total, service) => {
            return total + (parseInt(service.seating, 10) || 0);
        }, 0);

        const discountPercentage = parseFloat(formData.packageDiscount) || 0;
        const discountRs = parseFloat(formData.packageDiscountRs) || 0;
        const discountAmount = discountPercentage > 0
            ? (newTotalRate * discountPercentage) / 100
            : discountRs;

        const newTotalAmount = newTotalRate - discountAmount;

        return {
            newTotalRate,
            newTotalSeating,
            discountAmount,
            newTotalAmount,
        };
    };


    const addServices = (e) => {
        e.preventDefault();
        if (!selectedService2 || !serviceSeating) {
            toast.error("Please select a service and seating.");
            return;
        }

        const isDuplicate = packageServices.some(
            (service) => service.servicesName === selectedService2
        );

        if (isDuplicate) {
            toast.error("Service already added. Please select a different service.");
            return;
        }

        const newService = {
            servicesName: selectedService2,
            seating: parseInt(serviceSeating, 10),
            serviceRate: parseInt(formData.packageRate),
            serviceId: formData.serviceId
        };

        setPackageServices((prevServices) => {
            const updatedServices = [...prevServices, newService];

            const {
                newTotalRate,
                newTotalSeating,
                discountAmount,
                newTotalAmount,
            } = calculateTotals(updatedServices, isMultiplyChecked);

            setFormData((prev) => ({
                ...prev,
                packageRate: newTotalRate?.toFixed(0),
                packageQty: newTotalSeating,
                totalAmount: newTotalAmount?.toFixed(0),
                serviceDiscountAmount: discountAmount?.toFixed(0),
                service: formData.serviceId
            }));

            setTotalSeating(newTotalSeating);
            return updatedServices;
        });

        setSelectedService('');
        setServiceSeating('');
    };

    const handleDeleteService = (index) => {
        setPackageServices((prevServices) => {
            const updatedServices = prevServices.filter((_, i) => i !== index);

            const {
                newTotalRate,
                newTotalSeating,
                discountAmount,
                newTotalAmount,
            } = calculateTotals(updatedServices);

            setFormData((prev) => ({
                ...prev,
                packageRate: newTotalRate?.toFixed(0),
                packageQty: newTotalSeating,
                totalAmount: newTotalAmount?.toFixed(0),
                serviceDiscountAmount: discountAmount?.toFixed(0),
            }));

            setTotalSeating(newTotalSeating);
            return updatedServices;
        });

        setSelectedService('');
        setServiceSeating('');
    };


    useEffect(() => {
        console.log('Updated formData:', formData);
    }, [formData]);

    useEffect(() => {
        console.log('Updated packageServices:', packageServices);
    }, [packageServices]);

    const handleAllService = (res) => {
        setAllService(res)
    }

    const handleOtp = (e) => {
        const { name, value } = e.target;
        setOtpData((prev) => ({
            ...prev, [name]: value
        }))
    }

    const handleDeleteAppointment = () => {
        const payload = {
            billId: finalBillId,
            enteredOtp: otpData.enteredOtp
        }
        dispatch(finalBillDelete(payload, limits, userId, selectedDate)).then(() => {
            setOtpData({ enteredOtp: '' })
            setOtpModal(!otpModal);
        })
    }

    const [billDiscount, setBillDiscount] = useState(0);
    const [billDiscountPercentage, setBillDiscountPercentage] = useState(0);
    const [paidAmount, setPaidAmount] = useState(0);
    const [total, setTotal] = useState(0);
    const [totalGST, setTotalGST] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [payment, setPayment] = useState('')

    useEffect(() => {
        if (billData?.getConsultant?.data?.Billings?.length > 0) {
            const selectedBill = billData?.getConsultant?.data?.Billings?.filter(res => res.type === selectedOption);

            if (selectedBill && selectedBill.length > 0) {

                let billDiscount = 0
                let billDiscountPercentage = 0
                let paidAmount = 0
                let total = 0
                let serviceTotal = 0

                for (const selectBill of selectedBill) {
                    billDiscount += parseFloat(selectBill.serviceDiscountAmount) || 0;
                    billDiscountPercentage += parseFloat(selectBill.serviceDiscount) || parseFloat(selectBill.packageDiscount) || 0;
                    paidAmount += parseInt(selectBill.paidAmount) || 0;
                    total += parseInt(selectBill.serviceRate) || 0

                    serviceTotal += parseInt(selectBill.serviceTotal) || parseInt(selectBill.totalAmount) || 0;
                }
                if (!isNaN(billDiscount)) {
                    setBillDiscount(billDiscount);
                }
                if (!isNaN(billDiscountPercentage)) {
                    setBillDiscountPercentage(billDiscountPercentage);
                }
                if (!isNaN(paidAmount)) {
                    setPaidAmount(paidAmount);
                }
                if (!isNaN(total)) {
                    setTotal(total);
                }
                if (!isNaN(serviceTotal)) {
                    setTotalAmount(serviceTotal);
                }
                setTotalGST(0);
            }
        }

    }, [selectedOption, billData]);

    const handleFinalBill = () => {
        const { billRemark, paidAmount } = billDatas;
        if (!paidAmount) {
            toast.error('Paid Amount cannot be blank.');
            return;
        }

        // if (payment === '') {
        //     toast.error('Payment Type cannot be blank.');
        //     return;
        // }

        if (parseInt(paidAmount) > parseInt(totalAmount)) {
            toast.error('Paid Amount cannot be greater than Total Amount.');
            return;
        }

        let selectedIds = [];
        if (billData?.getConsultant?.data?.Billings?.length > 0) {
            selectedIds = billData?.getConsultant?.data?.Billings?.filter(res => res.type === selectedOption)
                .map(res => res._id);
        }

        const payload = {
            billIds: selectedIds,
            patientId: userId,
            billDiscount: billDiscount,
            billDiscountPercentage: billDiscountPercentage,
            billRemark: billDatas.billRemark,
            quantityTotalAmount: total,
            totalGst: totalGST,
            totalAmount: totalAmount,
            paidAmount: billDatas.paidAmount,
            paymentMethod: payment,
            date: formData.billDate
        }

        console.log('payload----', payload);

        dispatch(finalBill(payload, limits, userId, selectedDate, selectedOption1)).then(() => {
            setBillDatas({
                billRemark: '',
                paidAmount: '',
            })
            setPayment('')
            setBillDiscount('')
            setBillDiscountPercentage('')
            setTotal('')
            setTotalGST('')
            setTotalAmount('')
        })
    }

    const handleIds = () => {
        localStorage.setItem('id', id)
    }

    const updateBillCharge = () => {
        const paidAmount = parseFloat(formData.amount) || 0;
        const totalAmount = parseFloat(formData.totalAmount || formData.serviceTotal) || 0;
        const dueAmount = totalAmount - (formData.finalBilling?.paidAmount || 0);

        if (paidAmount > dueAmount) {
            toast.error('Paid amount cannot be greater than the due amount.');
            return;
        }

        const payload = {
            amount: formData.amount,
            paymentDate: new Date().toISOString(),  // current date/time in ISO format
            paymentMethod: payment,
        };


        dispatch(billHistory(historyId, payload, limits, userId, selectedDate, selectedOption1)).then(() => {
            billToggle()
            setPayment('')
        })
    }

    useEffect(() => {
        if (selectedOption === 'FILECHARGE') {
            const fileChargeEntry = fileCharges?.find((file) => file.fileName === 'File Charge');
            if (fileChargeEntry) {
                setFormData((prevData) => ({
                    ...prevData,
                    totalAmount: fileChargeEntry.fileCharge,
                    originalAmount: fileChargeEntry.fileCharge,
                }));
            }
        }
        if (selectedOption === 'CONSULTANT') {
            const fileChargeEntry = fileCharges?.find((file) => file.fileName === 'Consultant');
            if (fileChargeEntry) {
                setFormData((prevData) => ({
                    ...prevData,
                    totalAmount: fileChargeEntry.fileCharge,
                    originalAmount: fileChargeEntry.fileCharge,
                }));
            }
        }
    }, [selectedOption, fileCharges]);

    const handleBilling = async (history = null) => {
        const payload = {
            billingId: reportData?.finalBilling?._id
        };

        try {
            await dispatch(downloadBill(userId, payload, id));

            localStorage.setItem('billingId', reportData?.finalBilling?._id);

            if (history) {
                localStorage.setItem('historyId', history._id);
                setAllData([history]); // Pass only the selected row's data
            } else {
                setAllData(reportData?.finalBilling?.history); // Pass the entire bill's data
            }

            const newWindow = window.open('', '_blank');
            newWindowRef.current = newWindow;
        } catch (error) {
            console.error('Error downloading the bill:', error);
        }
    };

    useEffect(() => {
        if (allData && newWindowRef.current) {
            const newWindow = newWindowRef.current;
            newWindow.document.write(`
                <html>
                    <head>
                        <title>Generate Bill</title>
                        <style>
                            @media print {
                                body {
                                    margin: 0;
                                    padding: 0;
                                    background-color: #fff;
                                    font-family: "Arial, sans-serif",
                                }
                                .content {
                                    width: 100%;
                                    max-width: 595pt;
                                    height: 100vh;
                                    margin: 0 auto;
                                    box-sizing: border-box;
                                    overflow: hidden;
                                }
                                .content table {
                                    width: 100%;
                                    border-collapse: collapse;
                                }
                                .content table, .content th, .content td {
                                    page-break-inside: avoid;
                                }
                                .content * {
                                    font-size: 14px;
                                }
                                .content div, .content p, .content span {
                                    page-break-inside: avoid;
                                }
                            }
                            .content {
                                height:100vh;
                                transform: scale(0.95);
                                transform-origin: top left;
                            }
                        </style>
                    </head>
                    <body>
                        <div class="content">
                            ${billRef.current.innerHTML}
                        </div>
                    </body>
                </html>
            `);

            newWindow.document.close();

            newWindow.onload = () => {
                newWindow.print();
                newWindow.onafterprint = () => {
                    newWindow.close();
                };
            };

            setReadyToPrint(false);
        }
    }, [allData]);

    useEffect(() => {
        if (userId && (!selectedOption1 || selectedOption1 === "ALL")) {
            dispatch(finalBillByType(userId, "ALL"));
        } else if (userId && selectedOption1) {
            dispatch(finalBillByType(userId, selectedOption1));
        }
    }, [id, selectedOption1, userId, dispatch]);

    return (
        <>
            <div className="mt-[100px]">
                <div className='row justify-content-between border-b pb-4'>
                    <div className='col-6'>
                        <div className='flex items-center gap-3'>
                            <label className='block'>Patient Name :</label>
                            <div className="inline-flex gap-2 !text-gray-600 rounded-3 px-3 border-1 mt-1 items-center">
                                <h6 className="mb-0 text-sm">{branchData?.getAppointmentById?.data?.appointmentData?.firstName} {" "} {branchData?.getAppointmentById?.data?.appointmentData?.lastName}</h6>
                                <h6 className="border-l-[1px]  text-sm mb-0 py-2 px-2 !border-[#dadada] ">
                                    +91 {branchData?.getAppointmentById?.data?.appointmentData?.phoneNumber}
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className='col-6 text-end'>
                        <Link to={`/master/referralPage/${id}`} onClick={handleIds} className="bg-theme-dark text-white px-4 py-2 rounded me-3">Referral</Link>
                        <Link to={`/master/accountInfo/${id}`} onClick={handleIds} className="bg-theme-dark text-white px-4 py-2 rounded me-3">Account Info</Link>
                    </div>

                    <div className='flex justify-end gap-3 font-medium text-lg'>
                        <label className='text-center block text-gray-600 border-r pe-3'><span> Net Amount :</span> <span className='ms-1 border-b border-gray-600'>{billData?.finalBillByType?.data?.totalAmountSum}</span></label>
                        <label className='text-center block text-success border-r pe-3'><span>Received Amount : </span> <span className='ms-1 border-b border-success'>{billData?.finalBillByType?.data?.totalPaidAmountSum}</span></label>
                        <label className='text-center block text-danger'><span>Pending Amount : </span> <span className='ms-1 border-b border-danger'>{billData?.finalBillByType?.data?.totalPendingAmountSum}</span></label>
                    </div>
                </div>

                <div className='row mt-4 mb-5'>
                    <div className="col items-center">
                        <h5 className='mb-0'>Old Bill History</h5>
                    </div>

                    <div className='col text-end flex items-center justify-end gap-3'>
                        <div className=''>
                            <label className="text-sm block mb-1 text-start">Date</label>
                            <input
                                type="date"
                                name="date"
                                value={selectedDate}
                                onChange={handleDateChange}
                                className="w-full outline-none !border-b"
                            />
                        </div>
                        <div>
                            <select
                                onChange={handleChange1} value={selectedOption1 || 'ALL'}
                                className="ms-2 border w-[200px] px-2 py-1 rounded-md focus:outline-none"
                            >
                                <option value="ALL">All</option>
                                <option value="CONSULTANT">Consultation</option>
                                <option value="FILECHARGE">File Charge</option>
                                <option value="SERVICE">Services</option>
                                <option value="PACKAGE">Package</option>
                            </select>
                        </div>
                        <div>
                            Rows per page:
                            <select
                                value={rowsPerPage}
                                onChange={handleRowsPerPageChange}
                                className="ms-2 border rounded-md focus:outline-none"
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={30}>30</option>
                            </select>
                        </div>
                    </div>
                </div>

                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Date</Th>
                                <Th>Time</Th>
                                <Th>Bill No.</Th>
                                {/* <Th>Doctor Name</Th> */}
                                <Th>Service Name</Th>
                                <Th>Rate</Th>
                                <Th>Discount (%)</Th>
                                <Th>Discount (₹)</Th>
                                <Th>Total Amount</Th>
                                <Th>Paid Amount</Th>
                                <Th>Due Amount</Th>
                                <Th>Type</Th>
                                <Th>User</Th>
                                <Th>Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                billData?.finalBillData?.data?.Billings?.length > 0 ? (
                                    billData?.finalBillData?.data?.Billings?.filter(res =>
                                        selectedOption1 === 'ALL' ||
                                        res.type === selectedOption1
                                    ).map((res) => {
                                        return (
                                            <Tr>
                                                <Td>{new Date(res?.date).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</Td>
                                                <Td>{res.time}</Td>
                                                <Td>{res.billNumber}</Td>
                                                {/* <Td>{res.doctorName}</Td> */}
                                                <Td>{res.serviceName || res.packageName || '-'}</Td>
                                                <Td>{res?.serviceRate || '-'}</Td>
                                                <Td>{res.serviceDiscount || res.packageDiscount || res.filechargeDiscount || res.consultationDiscount || 0}</Td>
                                                <Td>{res.serviceDiscountRs || res.packageDiscountRs || res.filechargeDiscountRs || res.consultationDiscountRs || 0}</Td>
                                                <Td>{res.type === 'SERVICE' ? res.serviceTotal : res.type === "PACKAGE" ? res.serviceRate : res.totalAmount || 0}</Td>
                                                <Td>{res.finalBilling?.paidAmount}</Td>
                                                <Td>{res.totalAmount - res.finalBilling?.paidAmount || res.serviceTotal - res.finalBilling?.paidAmount || 0}</Td>
                                                <Td>{res.type}</Td>
                                                <Td>{res.authName}</Td>
                                                <Td>
                                                    <div className='flex items-center gap-3'>
                                                        <FaEdit className='text-success text-xl cursor-pointer' onClick={() => {
                                                            billToggle(); setFormData(res); setHistoryId(res?.finalBilling?._id); const date = new Date(res.date);
                                                            const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
                                                            setBillDate(formattedDate);
                                                        }} />
                                                        <FiTarget className='text-primary text-xl cursor-pointer' title='view' onClick={() => { reportToggle(); setReportData(res) }} />
                                                        <MdDelete className='text-danger text-xl cursor-pointer' onClick={() => { deleteFinalToggle(); seFinalBillId(res._id) }} />
                                                    </div>
                                                </Td>
                                            </Tr>
                                        )
                                    })
                                ) : (
                                    <Tr>
                                        <Td colSpan={12} textAlign={'center'}>No Any Bills</Td>
                                    </Tr>
                                )
                            }
                        </Tbody>
                    </Table>
                </TableContainer>

                <div className='flex items-center justify-end mt-3'>
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel="next >"
                        onPageChange={ChangeMainPage}
                        pageRangeDisplayed={5}
                        pageCount={PageCount}
                        previousLabel="< previous"
                        renderOnZeroPageCount={null}
                        className="pagination"
                    />
                </div>

                <div className='my-5'>
                    <div className='row'>
                        <div className="col-3">
                            <label htmlFor="bill" className='mb-1'>Bill For</label>
                            <Form.Select onChange={handleChange} value={selectedOption} className='shadow-none outline-none focus:!border-theme-dark'>
                                <option value="">Bill For</option>
                                <option value="CONSULTANT">Consultation</option>
                                <option value="FILECHARGE">File Charge</option>
                                <option value="SERVICE">Services</option>
                                <option value="PACKAGE">Package</option>
                            </Form.Select>
                        </div>
                        <div className="col-3">
                            <label htmlFor="bill" className='mb-1'>Doctor Name</label>
                            <Form.Group controlId="campaignDetail">
                                <div className="relative">
                                    <input
                                        name="doctorName"
                                        readOnly
                                        value={branchData?.getAppointmentById?.data?.appointmentData?.doctor}
                                        className="border w-full outline-none focus:!border-theme-dark rounded py-[6px] px-[12px]"
                                    // onClick={() => { setDoctorData1(!doctorData1); }}
                                    />

                                    {/* <div className={`${doctorData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}  >
                                        <input
                                            type="text"
                                            name="search"
                                            value={searchQuery}
                                            placeholder={`Search Doctors`}
                                            onChange={searchData}
                                            className="w-full border p-2 rounded outline-none"
                                        />
                                        {branchData?.allDoctor?.data?.doctor?.map((res) => (
                                            <p key={res._id} onClick={() => { selectDoctor(res.name); }} className="text-gray-700 py-1 cursor-pointer" > {res.name} </p>
                                        ))}
                                    </div> */}
                                </div>
                            </Form.Group>
                        </div>
                        <div className="col-3">
                            <label htmlFor="bill" className='mb-1'>Branch</label>
                            <Form.Control readOnly value={branchData?.getAppointmentById?.data?.appointmentData?.branch} className='shadow-none outline-none focus:!border-theme-dark' />
                        </div>
                        <div className="col-3">
                            <label htmlFor="bill" className='mb-1'>Appointment Date Time</label>
                            <Form.Control
                                type='text'
                                readOnly
                                value={branchData?.getAppointmentById?.data?.appointmentData?.dateOfAppointment
                                    ? formatDateTime(branchData?.getAppointmentById?.data?.appointmentData?.dateOfAppointment)
                                    : ''}
                                placeholder='Appointment date time'
                                className='shadow-none focus:!border-theme-dark'
                            />
                        </div>
                    </div>
                </div>

                {selectedOption === "FILECHARGE" && (
                    <div className='border-t my-5 pt-5'>
                        <h5 className='mb-5'>File Charge</h5>
                        <div onClick={toggle} className="w-[30px] ms-auto flex justify-center items-center h-[30px] rounded-circle !border-red-700 border-1 cursor-pointer">
                            <MdAdd className="fs-4 text-danger fw-bold" />
                        </div>
                        <TableContainer>
                            <Table variant="striped" colorScheme="blackAlpha">
                                <Thead>
                                    <Tr>
                                        <Th>Date</Th>
                                        <Th>Time</Th>
                                        <Th>Service Name</Th>
                                        <Th>Bill Number</Th>
                                        <Th>Doctor Name</Th>
                                        <Th>Discount (%)</Th>
                                        <Th>Discount (₹)</Th>
                                        <Th>Total Amount</Th>
                                        <Th>Action</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        billData?.getConsultant?.data?.Billings?.length > 0 ? (
                                            billData?.getConsultant?.data?.Billings?.map((res) => {
                                                return (
                                                    <>
                                                        {
                                                            res.type === 'FILECHARGE' && (
                                                                <Tr key={res._id}>
                                                                    <Td>{new Date(res.date).toLocaleDateString('en-GB')}</Td>
                                                                    <Td>{res.time}</Td>
                                                                    <Td>File Charge</Td>
                                                                    <Td>{res.billNumber}</Td>
                                                                    <Td>{res.doctorName}</Td>
                                                                    <Td>{res.filechargeDiscount || '-'}</Td>
                                                                    <Td>{res.filechargeDiscountRs || '-'}</Td>
                                                                    <Td>{res.totalAmount}</Td>
                                                                    <Td className='flex items-center gap-3'>
                                                                        <FaEdit className='text-success text-xl cursor-pointer' onClick={() => { updateToggle(); setBillId(res._id); setFormData(res); setSelectedDoctor(res.doctorName); }} />
                                                                        <MdDelete className='text-danger text-xl cursor-pointer' onClick={() => { deleteToggle(); setBillId(res._id) }} />
                                                                    </Td>
                                                                </Tr>
                                                            )
                                                        }
                                                    </>
                                                )
                                            })
                                        ) : (
                                            <Tr>
                                                <Td colSpan={9}>No any bills</Td>
                                            </Tr>
                                        )
                                    }
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </div>
                )}

                {selectedOption === "CONSULTANT" && (
                    <div className='border-t my-5 pt-5'>
                        <h5 className='mb-5'>Consultation Bill</h5>
                        <div onClick={toggle} className="w-[30px] ms-auto flex justify-center items-center h-[30px] rounded-circle !border-red-700 border-1 cursor-pointer">
                            <MdAdd className="fs-4 text-danger fw-bold" />
                        </div>
                        <TableContainer>
                            <Table variant="striped" colorScheme="blackAlpha">
                                <Thead>
                                    <Tr>
                                        <Th>Date</Th>
                                        <Th>Time</Th>
                                        <Th>Service Name</Th>
                                        <Th>Bill Number</Th>
                                        <Th>Doctor Name</Th>
                                        <Th>Discount (%)</Th>
                                        <Th>Discount (₹)</Th>
                                        <Th>Total Amount</Th>
                                        <Th>Action</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        billData?.getConsultant?.data?.Billings?.length > 0 ? (
                                            billData?.getConsultant?.data?.Billings?.map((res) => {
                                                return (
                                                    <>
                                                        {
                                                            res.type === 'CONSULTANT' && (
                                                                <Tr key={res._id}>
                                                                    <Td>{new Date(res.date).toLocaleDateString('en-GB')}</Td>
                                                                    <Td>{res.time}</Td>
                                                                    <Td>Consultation</Td>
                                                                    <Td>{res.billNumber}</Td>
                                                                    <Td>{res.doctorName}</Td>
                                                                    <Td>{res.consultationDiscount || '-'}</Td>
                                                                    <Td>{res.consultationDiscountRs || '-'}</Td>
                                                                    <Td>{res.totalAmount}</Td>
                                                                    <Td className='flex items-center gap-3'>
                                                                        <FaEdit className='text-success text-xl cursor-pointer' onClick={() => { updateToggle(); setBillId(res._id); setFormData(res); setSelectedDoctor(res.doctorName); }} />
                                                                        <MdDelete className='text-danger text-xl cursor-pointer' onClick={() => { deleteToggle(); setBillId(res._id) }} />
                                                                    </Td>
                                                                </Tr>
                                                            )
                                                        }
                                                    </>
                                                )
                                            })
                                        ) : (
                                            <Tr>
                                                <Td colSpan={9}>No any bills</Td>
                                            </Tr>
                                        )
                                    }
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </div>
                )}

                {selectedOption === "SERVICE" && (
                    <div className='border-t my-5 pt-5'>
                        <h5 className='mb-5'>Service Bill Form</h5>
                        <div onClick={() => { toggle(); }} className="w-[30px] ms-auto flex justify-center items-center h-[30px] rounded-circle !border-red-700 border-1 cursor-pointer">
                            <MdAdd className="fs-4 text-danger fw-bold" />
                        </div>
                        <TableContainer>
                            <Table variant="striped" colorScheme="blackAlpha">
                                <Thead>
                                    <Tr>
                                        <Th>Date</Th>
                                        <Th>Bill Number</Th>
                                        <Th>Service Name</Th>
                                        <Th>Rate</Th>
                                        <Th>Seating</Th>
                                        <Th>Discount (%)</Th>
                                        <Th>Discount (₹)</Th>
                                        <Th>Discount</Th>
                                        <Th>GST (%)</Th>
                                        <Th>Total</Th>
                                        <Th>Remark</Th>
                                        <Th>Action</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        billData?.getConsultant?.data?.Billings?.length > 0 ? (
                                            billData?.getConsultant?.data?.Billings?.map((res) => {
                                                return (
                                                    <>
                                                        {
                                                            res.type === 'SERVICE' && (
                                                                <Tr key={res._id}>
                                                                    <Td>{new Date(res.date).toLocaleDateString('en-GB')}</Td>
                                                                    <Td>{res.billNumber}</Td>
                                                                    <Td>{res.serviceName}</Td>
                                                                    <Td>{res.serviceRate}</Td>
                                                                    <Td>{res.serviceQty}</Td>
                                                                    <Td>{res.serviceDiscount || 0} %</Td>
                                                                    <Td>{res.serviceDiscountRs || 0}</Td>
                                                                    <Td>{res.serviceDiscountAmount}</Td>
                                                                    <Td title={res.serviceGst}>0</Td>
                                                                    <Td>{res.serviceTotal}</Td>
                                                                    <Td>{res.serviceRemark}</Td>
                                                                    <Td className='flex items-center gap-3'>
                                                                        <FaEdit className='text-success text-xl cursor-pointer' onClick={() => { updateToggle(); setBillId(res._id); setFormData(res); setSelectedService(res.serviceName) }} />
                                                                        <MdDelete className='text-danger text-xl cursor-pointer' onClick={() => { deleteToggle(); setBillId(res._id) }} />
                                                                    </Td>
                                                                </Tr>
                                                            )
                                                        }
                                                    </>
                                                )
                                            })
                                        ) : (
                                            <Tr>
                                                <Td colSpan={11}>No any bills</Td>
                                            </Tr>
                                        )
                                    }
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </div>
                )}

                {selectedOption === "PACKAGE" && (
                    <div className='border-t my-5 pt-5'>
                        <div className='mb-5 flex items-center justify-between'>
                            <h5>Package Bill Form</h5>
                            <div className='text-end'>
                                <Link to={`/master/voucher/${id}`} className="bg-theme-dark text-white px-4 py-2 rounded me-3">Voucher</Link>
                            </div>
                        </div>
                        <div onClick={toggle} className="w-[30px] ms-auto flex justify-center items-center h-[30px] rounded-circle !border-red-700 border-1 cursor-pointer">
                            <MdAdd className="fs-4 text-danger fw-bold" />
                        </div>
                        <TableContainer>
                            <Table variant="striped" colorScheme="blackAlpha">
                                <Thead>
                                    <Tr>
                                        <Th>Date</Th>
                                        <Th>Bill Number</Th>
                                        <Th>Services</Th>
                                        <Th>Seating</Th>
                                        <Th>Booked Seating</Th>
                                        <Th>Pending Seating</Th>
                                        <Th>Rate</Th>
                                        <Th>Discount (%)</Th>
                                        <Th>Discount (₹)</Th>
                                        <Th>Discount</Th>
                                        <Th>Total</Th>
                                        <Th>Action</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        billData?.getConsultant?.data?.Billings?.length > 0 ? (
                                            billData?.getConsultant?.data?.Billings?.map((res) => {
                                                return (
                                                    <>
                                                        {
                                                            res.type === 'PACKAGE' && (
                                                                <Tr key={res._id} className={`${res.totalPendingSeating === 0 ? 'bg-gray-700' : ''}`}>
                                                                    <Td>{new Date(res.date).toLocaleDateString('en-GB')}</Td>
                                                                    <Td>{res.billNumber}</Td>
                                                                    <Td className='cursor-pointer' onClick={() => { serviceToggle(); handleAllService(res) }}>{res.packageServices?.length}</Td>
                                                                    <Td>{res.totalSeating}</Td>
                                                                    <Td>{res.totalBookedSeating}</Td>
                                                                    <Td>{res.totalPendingSeating}</Td>
                                                                    <Td>{res.serviceRate}</Td>
                                                                    <Td>{res.packageDiscount || 0}</Td>
                                                                    <Td>{res.packageDiscountRs || 0}</Td>
                                                                    <Td>{res.serviceDiscountAmount || 0}</Td>
                                                                    <Td>{res.totalAmount}</Td>
                                                                    <Td className='flex items-center gap-3'>
                                                                        <FaEdit className='text-success text-xl cursor-pointer' onClick={() => { updateToggle(); setBillId(res._id); setFormData(res); setSelectedService(res.serviceName); setPackageServices(res.packageServices) }} />
                                                                        <MdDelete className='text-danger text-xl cursor-pointer' onClick={() => { deleteToggle(); setBillId(res._id) }} />
                                                                    </Td>
                                                                </Tr>
                                                            )
                                                        }
                                                    </>
                                                )
                                            })
                                        ) : (
                                            <Tr>
                                                <Td colSpan={12}>No any packages</Td>
                                            </Tr>
                                        )
                                    }
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </div>
                )}

                <div>
                    <Form.Check checked type={'checkbox'} label='is Consult From Submmited' />
                </div>

                <div className='flex items-center gap-3 mt-4'>
                    <div>
                        <label className='mb-1 block'>Bill Discount</label>
                        <input type="text" value={billDiscount} disabled placeholder='Bill Discount' className='border rounded-lg px-3 py-2 outline-none' />
                    </div>
                    <div>
                        <label className='mb-1 block'>Bill Discount (%)</label>
                        <input type="text" value={billDiscountPercentage} disabled placeholder='Bill Discount (%)' className='border rounded-lg px-3 py-2 outline-none' />
                    </div>
                    <div>
                        <label className='mb-1 block'>Remark</label>
                        <input type="text" value={billDatas.billRemark} name="billRemark" onChange={handleBill} placeholder='Enter Remark' className='border rounded-lg px-3 py-2 outline-none' />
                    </div>
                    <div>
                        <label className='mb-1 block'>Paid Amount</label>
                        <input type="text" value={billDatas.paidAmount} name="paidAmount" onChange={handleBill} placeholder='Enter Paid Amount' className='border rounded-lg px-3 py-2 outline-none' />
                    </div>
                </div>
                <div className='mt-4 flex items-center gap-3'>
                    <div>
                        <label className='mb-1 block'>Total</label>
                        <input type="text" value={total} disabled placeholder='Total' className='border rounded-lg px-3 py-2 outline-none' />
                    </div>
                    <div>
                        <label className='mb-1 block'>Total GST</label>
                        <input type="text" value={totalGST} disabled placeholder='Total GST' className='border rounded-lg px-3 py-2 outline-none' />
                    </div>
                    <div>
                        <label className='mb-1 block'>Total Amount</label>
                        <input type="text" value={totalAmount} placeholder='Total Amount' className='border rounded-lg px-3 py-2 outline-none' />
                    </div>
                    <div>
                        <label className='mb-1 block'>Payment Type</label>
                        <select name="paymentMethod" value={payment} onChange={(e) => { setPayment(e.target.value) }} id="" className='border rounded-lg px-3 py-2 w-[200px] outline-none'>
                            <option value="">Select type</option>
                            <option value="Pending">Pending</option>
                            <option value="Cash">Cash</option>
                            <option value="Online">Online</option>
                            <option value="Credit Card / Debit Card">Credit Card / Debit Card</option>
                            <option value="Online (Gpay)">Online (Gpay)</option>
                            <option value="Net banking">Net banking</option>
                        </select>
                        {/* <input type="text" value={totalAmount} placeholder='Total Amount' className='border rounded-lg px-3 py-2 outline-none' /> */}
                    </div>
                    <button onClick={handleFinalBill} className='self-end ms-auto px-4 py-2 bg-theme-dark text-white rounded-lg'>Submit</button>
                </div>
            </div >

            {/* add Bill */}
            < Modal show={show} onHide={toggle} >
                <Modal.Header closeButton>
                    <Modal.Title>Add {selectedOption && selectedOption.charAt(0).toUpperCase() + selectedOption.slice(1).toLowerCase()} Bill</Modal.Title>
                </Modal.Header>

                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    enableReinitialize
                    onSubmit={(values) => {
                        handleAddConslutant(values);
                    }}
                >
                    {({ handleSubmit, values, setFieldValue }) => (
                        <FormikForm onSubmit={handleSubmit}>

                            <Modal.Body>
                                <div className="row">
                                    {
                                        selectedOption === 'FILECHARGE' && (
                                            <>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Doctor Name</Form.Label>
                                                        <Form.Group controlId="campaignDetail">
                                                            <div className="relative">
                                                                <input
                                                                    name="doctorName"
                                                                    placeholder={selectedDoctor ? selectedDoctor : 'Select Doctor'}
                                                                    readOnly
                                                                    value={selectedDoctor}
                                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                                    onClick={() => { setDoctorData1(!doctorData1); setSearchType('Doctor'); }}
                                                                />

                                                                <div className={`${doctorData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}  >
                                                                    <input
                                                                        type="text"
                                                                        name="search"
                                                                        value={searchQuery}
                                                                        placeholder={`Search Doctors`}
                                                                        onChange={searchData}
                                                                        className="w-full border p-2 rounded outline-none"
                                                                    />
                                                                    {branchData?.allDoctor?.data?.doctor?.map((res) => (
                                                                        <p key={res._id} onClick={() => { selectDoctor(res.name); }} className="text-gray-700 py-1 cursor-pointer" > {res.name} </p>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </Form.Group>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Bill Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="billDate"
                                                            as={Form.Control}
                                                             onChange={handleData}
                                                            value={formData.billDate}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                        <ErrorMessage
                                                            name="billDate"
                                                            component="div"
                                                            className="text-danger"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Discount (%)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="filechargeDiscount"
                                                            as={Form.Control}
                                                            value={formData.filechargeDiscount}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Discount (₹)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="filechargeDiscountRs"
                                                            as={Form.Control}
                                                            value={formData.filechargeDiscountRs}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Total Amount</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="totalAmount"
                                                            as={Form.Control}
                                                            disabled
                                                            value={formData.totalAmount}
                                                            onChange={handleData}
                                                            placeholder="Enter Total Amount"
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )
                                    }
                                    {
                                        selectedOption === 'CONSULTANT' && (
                                            <>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Doctor Name</Form.Label>
                                                        <Form.Group controlId="campaignDetail">
                                                            <div className="relative">
                                                                <input
                                                                    name="doctorName"
                                                                    placeholder={selectedDoctor ? selectedDoctor : 'Select Doctor'}
                                                                    readOnly
                                                                    value={selectedDoctor}
                                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                                    onClick={() => { setDoctorData1(!doctorData1); setSearchType('Doctoer'); }}
                                                                />

                                                                <div className={`${doctorData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}  >
                                                                    <input
                                                                        type="text"
                                                                        name="search"
                                                                        value={searchQuery}
                                                                        placeholder={`Search Doctors`}
                                                                        onChange={searchData}
                                                                        className="w-full border p-2 rounded outline-none"
                                                                    />
                                                                    {branchData?.allDoctor?.data?.doctor?.map((res) => (
                                                                        <p key={res._id} onClick={() => { selectDoctor(res.name); }} className="text-gray-700 py-1 cursor-pointer" > {res.name} </p>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </Form.Group>
                                                    </Form.Group>
                                                </div>
                                                {/* <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Bill Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="billDate"
                                                            as={Form.Control}
                                                            value={formData.billDate}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div> */}
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Bill Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="billDate"
                                                            as={Form.Control}
                                                             onChange={handleData}
                                                            value={formData.billDate}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                        <ErrorMessage
                                                            name="billDate"
                                                            component="div"
                                                            className="text-danger"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Discount (%)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="consultationDiscount"
                                                            as={Form.Control}
                                                            value={formData.consultationDiscount}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Discount (₹)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="consultationDiscountRs"
                                                            as={Form.Control}
                                                            value={formData.consultationDiscountRs}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Total Amount</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="totalAmount"
                                                            as={Form.Control}
                                                            value={formData.totalAmount}
                                                            onChange={handleData}
                                                            disabled
                                                            placeholder="Enter Total Amount"
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )
                                    }
                                    {
                                        selectedOption === 'SERVICE' && (
                                            <>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Service Name</Form.Label>
                                                        <div className="relative">
                                                            <input
                                                                name="serviceName"
                                                                placeholder={selectedService ? selectedService : 'Select Service'}
                                                                readOnly
                                                                value={selectedService}
                                                                className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                                onClick={() => { setServiceData1(!serviceData1); setSearchType('Service'); }}
                                                            />

                                                            <div className={`${serviceData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}>
                                                                <input
                                                                    type="text"
                                                                    name="search"
                                                                    value={searchQuery}
                                                                    placeholder={`Search Service`}
                                                                    onChange={searchData}
                                                                    className="w-full border p-2 rounded outline-none"
                                                                />
                                                                {billData?.getAllServices?.data?.Services?.map((res) => (
                                                                    <p key={res._id} onClick={() => { selectService(res); }} className="text-gray-700 py-1 cursor-pointer" > {res.serviceName} </p>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Rate</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="serviceRate"
                                                            value={formData.serviceRate}
                                                            as={Form.Control}
                                                            disabled
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Seating</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="serviceQty"
                                                            value={formData?.serviceQty}
                                                            onChange={handleData}
                                                            as={Form.Control}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Bill Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="billDate"
                                                            as={Form.Control}
                                                            value={formData.billDate}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div> */}
                                                  <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Bill Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="billDate"
                                                            as={Form.Control}
                                                             onChange={handleData}
                                                            value={formData.billDate}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                        <ErrorMessage
                                                            name="billDate"
                                                            component="div"
                                                            className="text-danger"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Discount (%)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="serviceDiscount"
                                                            as={Form.Control}
                                                            value={formData.serviceDiscount}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Discount (₹)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="serviceDiscountRs"
                                                            as={Form.Control}
                                                            value={formData.serviceDiscountRs}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Total Amount</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="serviceTotal"
                                                            as={Form.Control}
                                                            value={formData.serviceTotal}
                                                            onChange={handleData}
                                                            disabled
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Remark</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="serviceRemark"
                                                            as={Form.Control}
                                                            value={formData.serviceRemark}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )
                                    }
                                    {
                                        selectedOption === 'PACKAGE' && (
                                            <>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Package Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="packageName"
                                                            value={formData.packageName}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className='col-12'>
                                                    <Form.Group className="mb-3 flex items-center">
                                                        <Form.Label className='mb-0'>Multiply</Form.Label>
                                                        <input
                                                            type="checkbox"
                                                            checked={isMultiplyChecked}
                                                            onChange={handleMultiplyChange}
                                                            className="shadow-none focus:!border-theme-dark ms-2 w-[16px] h-[16px] accent-[#B78234]"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Service Name</Form.Label>
                                                        <div className='flex items-center justify-between'>
                                                            <div className="relative">
                                                                <input
                                                                    name="packageServices"
                                                                    placeholder={selectedService2 ? selectedService2 : 'Select Service'}
                                                                    readOnly
                                                                    value={selectedService2}
                                                                    className="border !w-[300px] outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                                    onClick={() => { setServiceData2(!serviceData2); setSearchType('Service'); }}
                                                                />

                                                                <div className={`${serviceData2 ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}>
                                                                    <input
                                                                        type="text"
                                                                        name="search"
                                                                        value={searchQuery}
                                                                        placeholder={`Search Service`}
                                                                        onChange={searchData}
                                                                        className="w-full border p-2 rounded outline-none"
                                                                    />
                                                                    {billData?.getAllServices?.data?.Services?.map((res) => (
                                                                        <p key={res._id} onClick={() => { selectService1(res); }} className="text-gray-700 py-1 cursor-pointer" > {res.serviceName} </p>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <Form.Control
                                                                type="number"
                                                                name="packageQty"
                                                                placeholder='Seating'
                                                                value={serviceSeating}
                                                                onChange={(e) => setServiceSeating(e.target.value)}
                                                                className="shadow-none focus:!border-theme-dark !w-[100px]"
                                                            />
                                                            <button onClick={addServices} className="bg-theme-dark w-[38px] h-[38px] text-white rounded-md">+</button>
                                                        </div>
                                                    </Form.Group>
                                                    <div className="col-12 mb-3">
                                                        <ul>
                                                            {packageServices.map((service, index) => (
                                                                <div className='flex items-center justify-between'>
                                                                    <li key={index}>
                                                                        {service.servicesName} - Seating : {service.seating}
                                                                    </li>
                                                                    <MdDelete className='text-danger text-base cursor-pointer' onClick={() => handleDeleteService(index)} />
                                                                </div>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Rate</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="packageRate"
                                                            value={formData.packageRate}
                                                            onChange={handleData}
                                                            disabled
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Bill Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="billDate"
                                                            as={Form.Control}
                                                            value={formData.billDate}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Package Discount (%)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="packageDiscount"
                                                            value={formData.packageDiscount}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Package Discount (₹)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="packageDiscountRs"
                                                            as={Form.Control}
                                                            value={formData.packageDiscountRs}
                                                            onChange={handleData}
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Total Amount</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="totalAmount"
                                                            value={formData.totalAmount}
                                                            onChange={handleData}
                                                            disabled
                                                            className="shadow-none focus:!border-theme-dark"
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )
                                    }
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={toggle} className="px-4 bg-transparent border-[1px] text-black border-green-color" >
                                    Close
                                </Button>
                                {/* <Button type="submit" className="!bg-theme-dark border-0 px-4" onClick={handleAddConslutant}> */}
                                <Button type="submit" className="!bg-theme-dark border-0 px-4">
                                    Add
                                </Button>
                            </Modal.Footer>
                        </FormikForm>
                    )}
                </Formik>
            </ Modal>

            {/* update Bill */}
            < Modal show={updateModal} onHide={updateToggle} >
                <Modal.Header closeButton>
                    <Modal.Title>Update Consultation Bill</Modal.Title>
                </Modal.Header>

                <Form>
                    <Modal.Body>
                        <div className="row">
                            {
                                selectedOption === 'FILECHARGE' && (
                                    <>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Doctor Name</Form.Label>
                                                <Form.Group controlId="campaignDetail">
                                                    <div className="relative">
                                                        <input
                                                            name="doctorName"
                                                            placeholder={selectedDoctor ? selectedDoctor : 'Select Doctor'}
                                                            readOnly
                                                            value={selectedDoctor}
                                                            className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                            onClick={() => { setDoctorData1(!doctorData1); setSearchType('Doctor'); }}
                                                        />

                                                        <div className={`${doctorData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}  >
                                                            <input
                                                                type="text"
                                                                name="search"
                                                                value={searchQuery}
                                                                placeholder={`Search Doctors`}
                                                                onChange={searchData}
                                                                className="w-full border p-2 rounded outline-none"
                                                            />
                                                            {branchData?.allDoctor?.data?.doctor?.map((res) => (
                                                                <p key={res._id} onClick={() => { selectDoctor(res.name); }} className="text-gray-700 py-1 cursor-pointer" > {res.name} </p>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Form.Group>
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Bill Date</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="billDate"
                                                    as={Form.Control}
                                                    value={formData.billDate}
                                                    onChange={handleData}
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Discount (%)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="filechargeDiscount"
                                                    as={Form.Control}
                                                    value={formData.filechargeDiscount}
                                                    onChange={handleData}
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Discount (₹)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="filechargeDiscountRs"
                                                    as={Form.Control}
                                                    value={formData.filechargeDiscountRs}
                                                    onChange={handleData}
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Total Amount</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="totalAmount"
                                                    as={Form.Control}
                                                    value={formData.totalAmount}
                                                    onChange={handleData}
                                                    disabled
                                                    placeholder="Enter Total Amount"
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                    </>
                                )
                            }
                            {
                                selectedOption === 'CONSULTANT' && (
                                    <>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Doctor Name</Form.Label>
                                                <Form.Group controlId="campaignDetail">
                                                    <div className="relative">
                                                        <input
                                                            name="doctorName"
                                                            placeholder={selectedDoctor ? selectedDoctor : 'Select Doctor'}
                                                            readOnly
                                                            value={selectedDoctor}
                                                            className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                            onClick={() => { setDoctorData1(!doctorData1); setSearchType('Doctoer'); }}
                                                        />

                                                        <div className={`${doctorData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}  >
                                                            <input
                                                                type="text"
                                                                name="search"
                                                                value={searchQuery}
                                                                placeholder={`Search Doctors`}
                                                                onChange={searchData}
                                                                className="w-full border p-2 rounded outline-none"
                                                            />
                                                            {branchData?.allDoctor?.data?.doctor?.map((res) => (
                                                                <p key={res._id} onClick={() => { selectDoctor(res.name); }} className="text-gray-700 py-1 cursor-pointer" > {res.name} </p>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Form.Group>
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Total Amount</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="totalAmount"
                                                    as={Form.Control}
                                                    value={formData.totalAmount}
                                                    onChange={handleData}
                                                    disabled
                                                    placeholder="Enter Total Amount"
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                    </>
                                )
                            }
                            {
                                selectedOption === 'SERVICE' && (
                                    <>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Service Name</Form.Label>
                                                <div className="relative">
                                                    <input
                                                        name="serviceName"
                                                        placeholder={selectedService ? selectedService : 'Select Service'}
                                                        readOnly
                                                        value={selectedService}
                                                        className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                        onClick={() => { setServiceData1(!serviceData1); setSearchType('Service'); }}
                                                    />

                                                    <div className={`${serviceData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}>
                                                        <input
                                                            type="text"
                                                            name="search"
                                                            value={searchQuery}
                                                            placeholder={`Search Service`}
                                                            onChange={searchData}
                                                            className="w-full border p-2 rounded outline-none"
                                                        />
                                                        {billData?.getAllServices?.data?.Services?.map((res) => (
                                                            <p key={res._id} onClick={() => { selectService(res); }} className="text-gray-700 py-1 cursor-pointer" > {res.serviceName} </p>
                                                        ))}
                                                    </div>
                                                </div>
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Rate</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="serviceRate"
                                                    value={formData.serviceRate}
                                                    as={Form.Control}
                                                    disabled
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Seating</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="serviceQty"
                                                    value={formData?.serviceQty}
                                                    onChange={handleData}
                                                    as={Form.Control}
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Discount (%)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="serviceDiscount"
                                                    as={Form.Control}
                                                    value={formData.serviceDiscount}
                                                    onChange={handleData}
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Discount (₹)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="serviceDiscountRs"
                                                    as={Form.Control}
                                                    value={formData.serviceDiscountRs}
                                                    onChange={handleData}
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Total Amount</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="serviceTotal"
                                                    as={Form.Control}
                                                    value={formData.serviceTotal}
                                                    onChange={handleData}
                                                    disabled
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Remark</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="serviceRemark"
                                                    as={Form.Control}
                                                    value={formData.serviceRemark}
                                                    onChange={handleData}
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                    </>
                                )
                            }
                            {
                                selectedOption === 'PACKAGE' && (
                                    <>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Package Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="packageName"
                                                    value={formData.packageName}
                                                    onChange={handleData}
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className='col-12'>
                                            <Form.Group className="mb-3 flex items-center">
                                                <Form.Label className="mb-0">Multiply</Form.Label>
                                                <input
                                                    type="checkbox"
                                                    checked={isMultiplyChecked}
                                                    onChange={handleMultiplyChange}
                                                    className="shadow-none focus:!border-theme-dark ms-2 w-[16px] h-[16px] accent-[#B78234]"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Service Name</Form.Label>
                                                <div className='flex items-center justify-between'>
                                                    <div className="relative">
                                                        <input
                                                            name="packageServices"
                                                            placeholder={selectedService2 ? selectedService2 : 'Select Service'}
                                                            readOnly
                                                            value={selectedService2 || 'Select Service'}
                                                            className="border !w-[300px] outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                            onClick={() => { setServiceData2(!serviceData2); setSearchType('Service'); }}
                                                        />

                                                        <div className={`${serviceData2 ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}>
                                                            <input
                                                                type="text"
                                                                name="search"
                                                                value={searchQuery}
                                                                placeholder={`Search Service`}
                                                                onChange={searchData}
                                                                className="w-full border p-2 rounded outline-none"
                                                            />
                                                            {billData?.getAllServices?.data?.Services?.map((res) => (
                                                                <p key={res._id} onClick={() => { selectService1(res); }} className="text-gray-700 py-1 cursor-pointer" > {res.serviceName} </p>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <Form.Control
                                                        type="number"
                                                        name="seating"
                                                        placeholder="Seating"
                                                        value={serviceSeating}
                                                        className="shadow-none focus:!border-theme-dark !w-[100px]"
                                                        onChange={(e) => setServiceSeating(e.target.value)}
                                                    // disabled
                                                    />
                                                    <button onClick={addServices} className="bg-theme-dark w-[38px] h-[38px] text-white rounded-md">+</button>
                                                </div>
                                            </Form.Group>
                                            <div className="col-12">
                                                <ul className='!mb-3'>
                                                    {packageServices.map((service, index) => (
                                                        <div className='flex items-center justify-between mb-1'>
                                                            <li key={index}>
                                                                {service.servicesName} - Seating: {service.seating} - Rate: {service?.serviceRate}
                                                            </li>
                                                            <MdDelete className='text-danger text-base cursor-pointer' onClick={() => handleDeleteService(index)} />
                                                        </div>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Rate</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="packageRate"
                                                    value={formData.packageRate}
                                                    onChange={handleData}
                                                    disabled
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Package Discount (%)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="packageDiscount"
                                                    value={formData.packageDiscount}
                                                    onChange={handleData}
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Package Discount (₹)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="packageDiscountRs"
                                                    as={Form.Control}
                                                    value={formData.packageDiscountRs}
                                                    onChange={handleData}
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Total Amount</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="totalAmount"
                                                    value={formData.totalAmount}
                                                    onChange={handleData}
                                                    disabled
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                            </Form.Group>
                                        </div>
                                    </>
                                )
                            }
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={updateToggle} className="px-4 bg-transparent border-[1px] text-black border-green-color" >
                            Close
                        </Button>
                        <Button type="submit" className="!bg-theme-dark border-0 px-4" onClick={handleUpdateConslutant}>
                            Update
                        </Button>
                    </Modal.Footer>
                </Form>
            </ Modal>

            {/* delete Bill */}
            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className='p-5'>
                    <div>
                        <PiWarningCircleBold className='text-7xl w-100 text-danger' />
                    </div>
                    <div className='text-center mt-4'>
                        <h3>Are You Sure ?</h3>
                        <p className='text-md'>Do you really want to delete these records?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDeleteConsultat}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Service Modal */}
            <Modal show={serviceModal} onHide={serviceToggle} centered>
                <Modal.Body className='p-3'>
                    <Table>
                        <Thead>
                            <Tr>
                                <Th>Service Name</Th>
                                <Th>Seating</Th>
                                <Th>Booked Seating</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                allService?.packageServices?.map((res) => {
                                    return (
                                        <Tr key={res._id}>
                                            <Td>{res.servicesName}</Td>
                                            <Td>{res.seating}</Td>
                                            <Td>{res.bookedSeating}</Td>
                                        </Tr>
                                    )
                                })
                            }
                        </Tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer className='border-0'>
                    <Button
                        variant="secondary"
                        onClick={serviceToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Update Bill Modal */}
            <Modal show={billModal} onHide={billToggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Bill Charge</Modal.Title>
                </Modal.Header>
                <Modal.Body className='p-3'>
                    <Form.Group className="mb-3">
                        <Form.Label>Total Amount</Form.Label>
                        <Form.Control
                            type="text"
                            name="totalAmount"
                            as={Form.Control}
                            value={formData.totalAmount || formData.serviceTotal}
                            onChange={handleData}
                            disabled
                            placeholder="Enter Total Amount"
                            className="shadow-none focus:!border-theme-dark"
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Due Amount</Form.Label>
                        <Form.Control
                            type="text"
                            as={Form.Control}
                            value={formData.totalAmount - formData.finalBilling?.paidAmount || formData.serviceTotal - formData.finalBilling?.paidAmount || 0}
                            onChange={handleData}
                            disabled
                            placeholder="Enter Total Amount"
                            className="shadow-none focus:!border-theme-dark"
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Paid Amount</Form.Label>
                        <Form.Control
                            type="text"
                            name="amount"
                            as={Form.Control}
                            value={formData.amount}
                            onChange={handleData}
                            placeholder="Enter Paid Amount"
                            className="shadow-none focus:!border-theme-dark"
                        />
                    </Form.Group>
                    <div>
                        <label className='mb-1 block'>Payment Type</label>
                        <select name="paymentMethod" value={payment} onChange={(e) => { setPayment(e.target.value) }} id="" className='border rounded-lg px-3 py-2 w-full outline-none'>
                            <option value="">Select type</option>
                            <option value="Pending">Pending</option>
                            <option value="Cash">Cash</option>
                            <option value="Online">Online</option>
                            <option value="Credit Card / Debit Card">Credit Card / Debit Card</option>
                            <option value="Online (Gpay)">Online (Gpay)</option>
                            <option value="Net banking">Net banking</option>
                        </select>
                        {/* <input type="text" value={totalAmount} placeholder='Total Amount' className='border rounded-lg px-3 py-2 outline-none' /> */}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={billToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={updateBillCharge}
                        className="!bg-theme-dark border-0 px-4"
                    >
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* View Report */}
            <Modal show={reportModal} size="lg" onHide={reportToggle} centered>
                <Modal.Body className='p-3'>
                    <Table>
                        <Thead>
                            <Tr>
                                <Th>Payment Date</Th>
                                <Th>Payment Time</Th>
                                <Th>Payment Type</Th>
                                <Th>Paid Amount</Th>
                                <Th>Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                reportData?.finalBilling?.history?.map((res) => {
                                    return (
                                        <Tr key={res._id}>
                                            <Td>
                                                {res.paymentDate ? moment.utc(res.paymentDate).tz('Asia/Kolkata').format('DD/MM/YYYY') : ''}
                                            </Td>
                                            <Td>
                                                {res.paymentDate ? moment.utc(res.paymentDate).tz('Asia/Kolkata').format('hh:mm A') : ''}
                                            </Td>
                                            <Td>{res.paymentMethod}</Td>
                                            <Td>{res.amount}</Td>
                                            <Td><button className='px-4 py-2 bg-theme-dark text-white rounded-lg' onClick={() => { handleBilling(res) }}>Print</button></Td>
                                        </Tr>
                                    )
                                })
                            }
                        </Tbody>
                    </Table>

                    {
                        reportData?.type === 'PACKAGE' && (
                            <Table className='mt-4 border-t'>
                                <Thead>
                                    <Tr>
                                        <Th>Service Name</Th>
                                        <Th>Seating</Th>
                                        <Th>Booked Seating</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        reportData?.packageServices?.map((res) => {
                                            return (
                                                <Tr key={res._id}>
                                                    <Td>{res.servicesName}</Td>
                                                    <Td>{res.seating}</Td>
                                                    <Td>{res.bookedSeating}</Td>
                                                </Tr>
                                            )
                                        })
                                    }
                                </Tbody>
                            </Table>
                        )
                    }

                </Modal.Body>
                <Modal.Footer className='border-0'>
                    <button onClick={() => { handleBilling(); }} className='px-4 py-2 bg-theme-dark text-white rounded-lg me-auto'>Full Bill</button>
                    <Button
                        variant="secondary"
                        onClick={reportToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            <Index billRef={billRef} allData={allData} id={id} />

            {loader && (
                <div className="loaderAdd">
                    <div className="loader_line"><img src={logo} className="w-[130px]" /></div>
                </div>
            )}

            {/* delete final bill */}
            <Modal show={deleteFinal} onHide={deleteFinalToggle}>
                <Modal.Body className="p-5">
                    <div>
                        <PiWarningCircleBold className="text-7xl w-100 text-danger" />
                    </div>
                    <div className="text-center mt-4">
                        <h3>Are You Sure ?</h3>
                        <p className="text-md">
                            Do you really want to delete these records?
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer className="">
                    <Button
                        variant="secondary"
                        onClick={deleteFinalToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={otpToggle}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* otp modal open in click yes */}

            <Modal show={otpModal} onHide={otpToggle}>
                <Modal.Body className="p-5">
                    <Form.Group className="mb-3" controlId="problem">
                        <Form.Label>OTP</Form.Label>
                        <Form.Control
                            type="text"
                            name="enteredOtp"
                            value={otpData.enteredOtp}
                            onChange={handleOtp}
                            placeholder="Enter OTP"
                            className="shadow-none focus:!border-theme-dark"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="">
                    <Button
                        variant="secondary"
                        onClick={otpToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="!bg-theme-dark border-0 px-4"
                        onClick={handleDeleteAppointment}
                    >
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}